export default __webpack_public_path__ + "static/media/a82be7b28c6644530913e6dcffefccce.png";